import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Bewijsstuk, Knop } from '@app/core/interfaces/bewijsstukken';
import { Subscription } from 'rxjs';

@Component({
    selector: 'ins-documentary-evidence',
    templateUrl: './documentary-evidence.component.html',
    styleUrls: ['./documentary-evidence.component.scss'],
})
export class DocumentaryEvidenceComponent implements OnInit, OnDestroy {
    @Input() submitted: boolean = false;
    @Input() evidenceIndex: number;
    @Input() evidenceDocuments: Bewijsstuk;

    public showUploadForm: boolean = true;
    public upload_evidence: Knop = null;
    public exdo_form: UntypedFormGroup;

    private subscriptions = new Subscription();

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    ngOnInit(): void {
        if (this.evidenceDocuments.knoppen) {
            this.evidenceDocuments.knoppen.forEach((knop) => {
                if (knop.knop_naam === 'uploaden-bewijsstuk') {
                    this.upload_evidence = knop;
                }
            });
        }

        if (this.evidenceDocuments.document_id === 'EXDO') {
            if (this.evidenceDocuments.document.length > 0) {
                this.showUploadForm = true;
                this.createForm('J');
            } else {
                this.showUploadForm = false;
                this.createForm(null);
            }
        }
    }

    private createForm(checkbox_value: string): void {
        this.exdo_form = new UntypedFormGroup({
            exdo_checkbox: new UntypedFormControl(checkbox_value),
        });

        const exdoValueChanges = this.exdo_form
            .controls
            .exdo_checkbox
            .valueChanges
            .subscribe((value) => {
                if (value === 'J') {
                    this.showUploadForm = true;
                } else {
                    this.showUploadForm = false;
                }
            });
        this.subscriptions.add(exdoValueChanges);
    }
}
